<template>
  <div class="expert-list-container">
    <div v-if="experts.length === 0" class="empty">暂无数据</div>
    <div v-else class="expert-list">
      <div class="expert-item" v-for="expert in experts" :key="expert.id" @click="goToDetail(expert.id)">
        <div class="expert-image-wrapper">
          <img :src="expert.photo" :alt="expert.name" class="expert-image" />
        </div>
        <div class="expert-info">
          <h3 class="expert-name">{{ expert.name }}</h3>
          <p class="expert-title">{{ expert.title }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExpertList',
  props: {
    experts: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    goToDetail(id) {
      this.$router.push({ name: 'expertDetail', params: { id } })
    }
  }
}
</script>

<style scoped>
.expert-list-container {
  min-height: 400px;
}

.empty {
  text-align: center;
  padding: 50px;
  font-size: 16px;
  color: #999;
}

.expert-list {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 20px;
  justify-content: flex-start;
}

.expert-item {
  width: calc((100% - 60px) / 4);
  background: linear-gradient(180deg, #B8D9E8 0%, #E8F4F9 100%);
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  box-sizing: border-box;
}

.expert-image-wrapper {
  width: 100%;
  height: 280px;
  overflow: hidden;
  position: relative;
}

.expert-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.expert-item:hover .expert-image {
  transform: scale(1.1);
}

.expert-info {
  padding: 15px;
  background: linear-gradient(180deg, #B8D9E8 0%, #E8F4F9 100%);
}

.expert-name {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin: 0 0 8px 0;
}

.expert-title {
  font-size: 14px;
  color: #666;
  margin: 0;
  line-height: 1.4;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .expert-item {
    width: calc((100% - 40px) / 3);
  }
}

@media (max-width: 768px) {
  .expert-item {
    width: calc((100% - 20px) / 2);
  }
}

@media (max-width: 480px) {
  .expert-item {
    width: 100%;
  }
}
</style>
